import { render, staticRenderFns } from "./_base-headline.vue?vue&type=template&id=5d421712&functional=true&"
import script from "./_base-headline.vue?vue&type=script&lang=js&"
export * from "./_base-headline.vue?vue&type=script&lang=js&"
import style0 from "./_base-headline.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports